import { render, staticRenderFns } from "./PromotionPriority.vue?vue&type=template&id=76069346&"
import script from "./PromotionPriority.vue?vue&type=script&lang=ts&"
export * from "./PromotionPriority.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports